import React, { memo, useEffect, useState } from 'react';
import ItemEditor from './ItemEditor';
import { Icon } from '../../common/AppShell';

function CategoryEditor({ category, items, allItems, onUpdate }) {
  const [editingItems, setEditingItems] = useState(allItems || items);

  useEffect(() => {
    setEditingItems(allItems || items);
  }, [allItems, items]);

  const handleChange = (id, updatedItem) => {
    const newItems = editingItems.map((item, index) =>
      (item.id || index) === id ? updatedItem : item
    );
    setEditingItems(newItems);
    onUpdate(newItems);
  };

  const addItem = () => {
    const newItem = { id: Date.now(), name: '', price: '', image: '', description: '', onStop: false };
    const newItems = [...editingItems, newItem];
    setEditingItems(newItems);
    onUpdate(newItems);
  };

  const deleteItem = (id) => {
    const newItems = editingItems.filter((item, index) => (item.id || index) !== id);
    setEditingItems(newItems);
    onUpdate(newItems);
  };

  const visibleIds = new Set(items.map((item, index) => item.id || index));

  return (
    <section className="menu-section">
      <div className="menu-section-header">
        <h2>{category}</h2>
        <button type="button" aria-label="Настройки категории">
          <Icon name="more_vert" />
        </button>
      </div>

      <div className="menu-item-list">
        {editingItems.map((item, index) => {
          const id = item.id || index;
          if (!visibleIds.has(id)) return null;

          return (
            <ItemEditor
              key={id}
              item={item}
              onChange={(updatedItem) => handleChange(id, updatedItem)}
              onDelete={() => deleteItem(id)}
            />
          );
        })}
      </div>

      <button type="button" onClick={addItem} className="add-row-button">
        <Icon name="add" />
        Добавить позицию
      </button>
    </section>
  );
}

export default memo(CategoryEditor);
